import { useCallback, useEffect, useState } from 'react';

import { addEventListener, removeEventListener } from 'Lib/utils/mediaQueryListener';

import { mobileLandscapeQuery } from 'Components/MediaQuery/mobileDesktopBreakpointQuery';

const useHorizontalLock = ({ isMobile }: { isMobile: boolean }) => {
  const [horizontalLock, setHorizontalLock] = useState(false);

  const landscapeLock = useCallback(
    (e) => {
      const { matches } = e ?? {};
      // only lock small screen size
      const shouldLockScreen = isMobile && matches;
      // only lock small screen device
      setHorizontalLock(shouldLockScreen);
    },
    [isMobile]
  );

  useEffect(() => {
    addEventListener(mobileLandscapeQuery, landscapeLock);

    landscapeLock(mobileLandscapeQuery);

    return () => {
      removeEventListener(mobileLandscapeQuery, landscapeLock);
    };
  }, [landscapeLock]);

  return {
    horizontalLock,
  };
};

export default useHorizontalLock;
